export function formatCurrency(amount: number, currency: string = 'USD'): string {
  // `currencyDisplay: 'narrowSymbol'` forces the glyph form (£, $, €, ₹,
  // ...) instead of the ISO code that some locales / browsers default
  // to (e.g. "USD 10.00" or "INR 100.00"). The checkout page is the
  // most visible consumer of this; without the override Indian rupee
  // and a handful of other currencies render as their code, which
  // confuses customers and looks like a bug.
  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      currencyDisplay: 'narrowSymbol',
    }).format(amount);
  } catch {
    // Older Safari versions / unknown currency strings throw on
    // narrowSymbol — fall back to the default symbol output.
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
    }).format(amount);
  }
}
